// Auto-generated by brandBuild.js — do not edit
export const externalImages = {
}
